import React, { useState } from "react";
import { PRODUCTS } from "../mock/mock";
import { malletSVG, fmt } from "../lib/mallet";
import { useCart } from "../context/CartContext";

const FILTERS = [
  ["all", "All"],
  ["mallet", "Mallets"],
  ["custom", "Painted & engraved"],
  ["set", "Team sets"],
  ["repair", "Repairs"],
];

function ProductCard({ p }) {
  const { addToCart } = useCart();
  const [len, setLen] = useState(52);

  const handleAdd = () => {
    const lenStr = p.lengths ? `${len}\"` : "";
    addToCart({
      key: p.id + lenStr,
      name: p.name,
      detail: p.lengths ? `Length ${len}\"` : "Repair service",
      price: p.price,
      spec: { length: p.lengths ? len : 52, ...p.spec },
    });
  };

  return (
    <article className="product">
      <div className="art" dangerouslySetInnerHTML={{ __html: malletSVG({ length: 52, ...p.spec }, { vertical: true }) }} />
      <div className="body">
        {p.tag ? <span className="tag">{p.tag}</span> : null}
        <h3>{p.name}</h3>
        <div className="meta">{p.meta}</div>
        <div className="row">
          <span className="price">{fmt(p.price)}</span>
          {p.lengths ? (
            <select aria-label="Length" value={len} onChange={e => setLen(parseInt(e.target.value))}>
              {[49, 50, 51, 52, 53, 54].map(l => <option key={l} value={l}>{l}"</option>)}
            </select>
          ) : null}
        </div>
        <button className="btn btn-paper" style={{ marginTop: ".75rem", justifyContent: "center" }} onClick={handleAdd}>Add to cart</button>
      </div>
    </article>
  );
}

export default function Shop() {
  const [filter, setFilter] = useState("all");
  const items = PRODUCTS.filter(p => filter === "all" || p.cat === filter);

  return (
    <section id="shop">
      <div className="wrap">
        <div className="sec-head">
          <h2>Shop the rack</h2>
          <p>Standard lengths 49"–54". Tell us your pony's height and we'll recommend one. Every mallet ships within 5 business days.</p>
        </div>
        <div className="filters" role="group" aria-label="Filter products">
          {FILTERS.map(([f, label]) => (
            <button key={f} className="chip" aria-pressed={filter === f} onClick={() => setFilter(f)}>{label}</button>
          ))}
        </div>
        <div className="products">
          {items.map(p => <ProductCard key={p.id} p={p} />)}
        </div>
      </div>
    </section>
  );
}
